export default "__VITE_ASSET__UK$W4ymb__"